// Menu items for a SPOC's spoc type dropdown: the service type's active spoc
// types, after "None" since the field is optional. A saved spoc type that has
// since been deactivated is kept, so the SPOC still shows what it is saved with.
export function getSpocTypeMenuItems(spocTypes, spocType) {
  const menuItems = [
    { label: "None", value: "" },
    ...spocTypes.map((type) => ({ label: type.name, value: type.name })),
  ];
  if (spocType && !spocTypes.some((type) => type.name === spocType)) {
    menuItems.push({ label: spocType, value: spocType });
  }
  return menuItems;
}

export default getSpocTypeMenuItems;
